import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <select
      value={i18n.language}
      onChange={changeLanguage}
      className="bg-gray-800 text-white text-sm rounded-md border border-gray-700 px-2 py-1 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-600 transition-colors"
    >
      <option value="en">🇺🇸 EN</option>
      <option value="vi">🇻🇳 VN</option>
    </select>
  );
}
